/*
 * @Author: zdx 3539255028@qq.com
 * @Date: 2022-06-01 09:51:28
 * @LastEditors: zdx 3539255028@qq.com
 * @LastEditTime: 2022-06-02 17:34:21
 * @FilePath: \jeecg-boot-v3\src\directives\businessPermission.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { usePermissionStoreWithOut } from '/@/store/modules/permission';
import type { Directive, App, DirectiveBinding } from 'vue';

const permissionStore = usePermissionStoreWithOut();

const hasRole = (el: Element, binding: DirectiveBinding<any>) => {
    const { businessPermission } = permissionStore;
    const { value } = binding;
    if (!value) return;
    if (!businessPermission.find((role: string) => role === value)) {
        el.parentNode?.removeChild(el);
    }
};

const mounted = (el: Element, binding: DirectiveBinding<any>) => {
    hasRole(el, binding);
};

const updated = (el: Element, binding: DirectiveBinding<any>) => {
    hasRole(el, binding);
};

const hasRoleDirective: Directive = {
    mounted,
    updated,
};

export function setupBusinessPermission(app: App) {
    app.directive('hasRole', hasRoleDirective);
}

export default hasRoleDirective;
